/**
 * Shop refuse reason residual (SPY-1408 / Loop 16 ECO; SPY-1607 already_owned;
 * SPY-1707 / FID-ECO-05 out_of_range shop-access;
 * SPY-1907 / FID-ECO-06 entity helper + enemy-fountain refuse).
 */
export const SHOP_REFUSE_REASONS = Object.freeze({
  NOT_DEAD: 'not_dead',
  NOT_ENOUGH_GOLD: 'not_enough_gold',
  INVENTORY_FULL: 'inventory_full',
  UNKNOWN_ITEM: 'unknown_item',
  OUT_OF_RANGE: 'out_of_range',
  ALREADY_OWNED: 'already_owned'
});

export function normalizeShopRefuseReason(reason) {
  if (!reason) return null;
  const known = Object.values(SHOP_REFUSE_REASONS);
  return known.includes(reason) ? reason : String(reason);
}

/** Map canShop (e.g. canShopInAram) to refuse reason; death-shop / in-zone → null. */
export function shopAccessRefuseReason(canShop) {
  if (canShop) return null;
  return SHOP_REFUSE_REASONS.OUT_OF_RANGE;
}

/** Entity + canShop fn → refuse; missing entity/fn is out_of_range (FID-ECO-07). */
export function shopAccessRefuseReasonForEntity(entity, canShopFn) {
  if (!entity || typeof canShopFn !== 'function') return SHOP_REFUSE_REASONS.OUT_OF_RANGE;
  return shopAccessRefuseReason(canShopFn(entity));
}
